import React, { Component, Fragment } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
    BASE_URL_ADMIN
} from '../../../data/config';
class TopChoice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            imageIdShow: 0,
            items: [
                
            ],
        }
    }
    showImage(imageIdShow, e) {
        e.preventDefault();
        this.setState({ show: true, imageIdShow });
        this.initJquery();
    }
    hiddenImage(e) {
        e.preventDefault();
        this.setState({ show: false });   
    }
    changeImageShow(type, e) {
        e.preventDefault();
        let items = this.props.topChoices;
        let { imageIdShow } = this.state;
        if (type == "next") {
            imageIdShow += 1;
            if (imageIdShow >= items.length) imageIdShow = items.length - 1;
        } else if (type == "previous") {
            imageIdShow -= 1;
            if (imageIdShow <= 0) imageIdShow = 0;
        }
        this.setState({ imageIdShow });
        this.initJquery();
    }
    initJquery() {
        let self = this;
        jQuery(document).ready(function($) {
        // window.addEventListener("load", function() {
            $('.page-see-more .description-lightbox').removeClass('show-less-hide');
            var heightDetail = $('.page-see-more .description-lightbox');
            if($(heightDetail).height() > 40){
                $(heightDetail).addClass('show-less-hide');
                $(heightDetail).parent().find('.read-more').show();
                $(heightDetail).parent().find('.read-more').html('Read More.. >>');
            }
            else{
                $(heightDetail).parent().find('.read-more').hide();
                $(heightDetail).parent().find('.read-more').html('Show Less.. >>');
            }
        });
    }

    initTopChoice(){
        let self = this;
        do_action('get_supplier_detail', {id: this.props.match.params.suplier_id})
            .then(response => {
                self.setState({
                    name: response.data.name,
                    banner: response.data.banner,
                    logo: response.data.logo,
                    id: response.data._id,
                    excerpt: response.data.excerpt,
                    address: response.data.address_long,
                    lat: parseInt(response.data.address_lat),
                    lng: parseInt(response.data.address_lng)
                });

            })
            .catch(err => console.log(err));
    }
    renderSlides() {
        let totalTopChoices = this.props.topChoices.length;
        let totalSlide      = Math.ceil(totalTopChoices / 10);
        let slides = [];
        for (let idx = 0; idx < totalSlide; idx++) {
            slides.push(idx);
        }
        const settings = {
            dots: false,
            centerMode: false,
            infinite: false,
            speed: 500,
            autoplaySpeed: 3000,
            autoplay: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            ]
 
        };
        return slides.map((item, idx) => {
            return (
                <Slider {...settings} key={`slide-${idx}`} >
                    {this.renderItems(idx)}
                </Slider>
            );
        });
    }
    renderItems = (slideId) => {
        var limit = 10;
        var start = slideId * limit;
        var end   = slideId * limit + (limit - 1); 
        return this.props.topChoices.map((item,index) => {
            if (index >= start && index <= end) {
                return (
                    <div className="item-slide" key={`slide-item-${index}`} onClick={ this.showImage.bind(this, index)}>
                        <a href="#" className="btn-slide">
                            <div className="img-hover">
                                <img src={BASE_URL_ADMIN + item.image} alt="Ruhu"/>
                                <div className="background"></div>
                                <div className="name">{item.name}</div>
                            </div>
                        </a>
                    </div>
                );
            }
        });
    }
    render() {
        
        return (
            <Fragment>
                <div className="top-choice" >
                    <div className="container">
                        <h3 className="title-detail">Top Choices</h3>
                        { this.renderSlides() }
                    </div>
                    { (this.state.show == true) ? (
                    <div className="lightbox" >
                        <div className="sldier-lightbox">
                            <div className="container-lightbox">
                                <div></div>
                                <button className="btn-lightbox btn-left" onClick={ this.changeImageShow.bind(this, 'previous') }><img src={'/images/left.png'} alt="Ruhu"/></button>
                                <button className="btn-lightbox btn-right" onClick={ this.changeImageShow.bind(this, 'next') }><img src={'/images/right.png'} alt="Ruhu"/></button>

                                <div className="wrapper-lightbox">
                                    <div className="item-lightbox">
                                        <div className="click-body" onClick={this.hiddenImage.bind(this)}></div>
                                        <div className="inline-item-wrapper">
                                            <button className="close-lightbox" onClick={this.hiddenImage.bind(this)} >&times;</button>
                                            <div className="inline-item">
                                                <div className="img-inline-item">
                                                    <a href={this.props.topChoices[this.state.imageIdShow].link} target="_blank"><img src={ BASE_URL_ADMIN +  this.props.topChoices[this.state.imageIdShow].image } alt="Ruhu"/></a>
                                                </div>
                                                <div className="info page-see-more">
                                                    <div className="title">{ this.props.topChoices[this.state.imageIdShow].name }</div>
                                                    <div className="description-lightbox">{ this.props.topChoices[this.state.imageIdShow].description }</div>
                                                    <div className="read-more text-right">Read More.. >></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        ) : null}
                </div>
            </Fragment>
        );
    }
}

export default TopChoice